module.exports = __webpack_public_path__ + "img/logo-rte.8a599dee.png";